import { useEffect, useRef, useState } from "react";
import {
  DivideSquare,
  List,
  MinusCircle,
  Search,
  Upload,
  UploadCloud,
} from "react-feather";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadBulkTemplate } from "../../api/customerChargesApi";
import {
  dedTxnDelete,
  getApprovedUserData,
} from "../../api/finance/ApprovalProcessApi";
import {
  addDeductionMaster,
  checkApprovePartyAvailability,
  DeductionExcelLinesById,
  deductionMasterById,
  reportSearchDeductionMaster,
  searchBulkDeduction,
  searchDeductionMaster,
  updateDeductionMaster,
  uploadDeductionBulkData,
} from "../../api/finance/deductionMasterApi";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import Tab from "../../components/Tab";
import DeductionBulkUpload from "../../components/finance/deduction/DeductionBulkUpload";
import DeductionMasterForm from "../../components/finance/deduction/DeductionMasterForm";
import ActionMenu from "../../components/input/ActionMenu";
import Button from "../../components/input/Button";
import CustomAlert from "../../components/input/CustomAlert";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import {
  ActiveCellStyle,
  BulkProceedStatusStyle,
  ChargeCellStyle,
  DateCellRenderer,
  DateOnlyCellRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import {
  deductionFuelValidation,
  deductionMasterValidation,
} from "../../components/validations/DeductionCreation";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import { errorActions } from "../../store/error-slice";

const DeductionMaster = () => {
  const errorState = useSelector((state) => state.error.deductMasterErrors);
  const user = useSelector((state) => state.user);
  const userCompany = useUserCompany();
  const dispatch = useDispatch();

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const [editDeduction, setEditDeduction] = useState({});
  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const deductionPermissions = auth[FORMS.DEDUCTION.DEDUCTION_MASTER.form];
  const downloadPermission = deductionPermissions?.FORM?.DOWNLOAD;

  // drawer tabs
  const [drawerTab, setDrawerTab] = useState(1);
  const [isBulkDrawerOpen, setIsBulkDrawerOpen] = useState(false);
  const [isBulkResponseDrawerOpen, setIsBulkResponseDrawerOpen] =
    useState(false);
  const [tab, setTab] = useState(1);

  //flags
  const [searchClicked, setSearchClicked] = useState(false);
  const [reportSearchClicked, setReportSearchClicked] = useState(false);
  const [bulkSearchClicked, setBulkSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [reportSearchFetchLoading, setReportSearchFetchLoading] =
    useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [reportSearchSubmitLoading, setReportSearchSubmitLoading] =
    useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [reportSearchRes, setReportSearchRes] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  // tab ref
  const deductionCreationRef = useRef();
  const deductionBulkUploadRef = useRef();

  //search ref
  const codeRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const versionNumber = useRef(null);

  //search State
  const [transporter, setTransporter] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [item, setItem] = useState(null);
  const [period, setPeriod] = useState(null);
  const [job, setJob] = useState(null);
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);

  // report

  const [reportSupplier, setReportSupplier] = useState(null);
  const [reportTransporter, setReportTransporter] = useState(null);
  const [reportVehicle, setReportVehicle] = useState(null);
  const [reportItemType, setReportItemType] = useState(null);
  const [reportItem, setReportItem] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [reportStatus, setReportStatus] = useState(null);
  const [reportActive, setReportActive] = useState(null);
  const [detId, setDetId] = useState(null);
  const [detCode, setDetCode] = useState(null);
  const deleteRef = useRef(null);

  const [isDeleting, setIsDeleting] = useState(false);
  const [updateNeeded, setUpdateNeeded] = useState(false);

  // report approver popup
  const [showCloseButton, setShowCloseButton] = useState(false);
  const modalRef = useRef();
  const [tableData, setTableData] = useState([]);

  // dropdown
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [dedPeriodOptions, setDedPeriodOptions] = useState([]);
  const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);

  const [currency, setCurrency] = useState(
    userCompany ? userCompany.comCurrency : null
  );
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );

  //bulk

  const [dedBulkSearchRes, setDedBulkSearchRes] = useState(false);
  const [dedBulkDetailSearchRes, setDedBulkDetailSearchRes] = useState(false);
  const [bulkProceedStatus, setBulkProceedStatus] = useState(null);

  //search useStates
  const [chargeType, setChargeType] = useState(null);

  // dropdown
  const [bulkProceedStatusOptions, setBulkProceedStatusOptions] =
    useState(null);
  const [chargeCateOpt, setChargeCateOpt] = useState([]);

  useEffect(() => {
    (async () => {
      if (drawerTab === 2) {
        const bulkProStat = await getDropdownData("bulk_proceed_status");
        setBulkProceedStatusOptions(bulkProStat);

        const chargeCategories = await getDropdownData("chg_category");
        const chargeCategoryData = chargeCategories.filter((item) =>
          [1, 2].includes(item.key)
        );
        setChargeCateOpt(chargeCategoryData);
      }
    })();
  }, [drawerTab]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setIsSearchLoading(true);

      const {
        status: statusData,
        active: activeData,
        item_type: itemType,
        deduction_period: period,
        payment_status: paymentStatus,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        { key: "item_type" },
        { key: "deduction_period" },
        { key: "payment_status" },
      ]);
      setActiveOptions(activeData);
      setStatusOptions(statusData);
      setItemTypeOptions(itemType);
      setDedPeriodOptions(period);
      setPaymentStatusOptions(paymentStatus);

      setIsLoading(false);
      setIsSearchLoading(false);
    })();
  }, []);

  useEffect(() => {
    setCurrency(userCompany ? userCompany.comCurrency : null);
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const handleDrawerOpen = () => {
    dispatch(errorActions.clearDeductMasterError());
    setEditMode(false);
    setEditDeduction(null);
    if (tab === 1) {
      setIsDrawerOpen(true);
    } else {
      setIsBulkDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    dispatch(errorActions.clearDeductMasterError());
    const deductMasterErrors = deductionMasterValidation(
      deductionCreationRef.current.getData()
    );
    let deductFuelErrors = [];
    if (deductionCreationRef.current.getData().dedItemType === 6) {
      deductFuelErrors = deductionFuelValidation(
        deductionCreationRef.current.getData()
      );
    }

    if (
      Object.keys(deductMasterErrors).length > 0 ||
      Object.keys(deductFuelErrors).length > 0
    ) {
      dispatch(
        errorActions.validateDeductMaster({
          deductMasterData: deductionCreationRef.current.getData(),
        })
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Deduction", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      const approvers = await checkApprovePartyAvailability(
        deductionCreationRef.current.getData().dedItemType
      );

      if (!approvers) {
        setIsSubmitLoading(false);
        toast.error(
          "There was an error adding Deduction. PLEASE ASSIGN APPROVER FIRST",
          { autoClose: 5000, containerId: "Main" }
        );
        return;
      }
      if (editMode) {
        try {
          const response = await updateDeductionMaster({
            dedId: deductionCreationRef.current.getData().dedId,
            dedReference: deductionCreationRef.current.getData().dedReference,
            dedCompany: company,
            dedCurrency: currency,
            dedTransporter:
              deductionCreationRef.current.getData().dedTransporter,
            dedVehicle: deductionCreationRef.current.getData().dedVehicle,
            dedItem: deductionCreationRef.current.getData().dedItem,
            dedItemType: deductionCreationRef.current.getData().dedItemType,
            dedPeriod: deductionCreationRef.current.getData().dedPeriod,
            dedStart: deductionCreationRef.current.getData().dedStart,
            dedEnd: deductionCreationRef.current.getData().dedEnd,
            dedRequiredDate:
              deductionCreationRef.current.getData().dedRequiredDate,
            dedExecutionDate:
              deductionCreationRef.current.getData().dedExecutionDate,
            dedItemCost: deductionCreationRef.current.getData().dedItemCost,
            dedQuantity: deductionCreationRef.current.getData().dedQuantity,
            dedAmount: deductionCreationRef.current.getData().dedAmount,
            dedInstallmentAmount:
              deductionCreationRef.current.getData().dedInstallmentAmount,
            dedInstallments:
              deductionCreationRef.current.getData().dedInstallments,
            dedPaymentStatus:
              deductionCreationRef.current.getData().dedPaymentStatus,
            dedSerialNumber:
              deductionCreationRef.current.getData().dedSerialNumber,
            dedDescription:
              deductionCreationRef.current.getData().dedDescription,
            dedWarranty: deductionCreationRef.current.getData().dedWarranty,
            dedWarrantyEnds:
              deductionCreationRef.current.getData().dedWarrantyEnds,
            dedJob: deductionCreationRef.current.getData().dedJob,
            dedDistance: deductionCreationRef.current.getData().dedDistance,
            dedFuelInstruction:
              deductionCreationRef.current.getData().dedFuelInstruction,
            dedBehalfOf: deductionCreationRef.current.getData().dedBehalfOf,
            dedApprovalLevels:
              deductionCreationRef.current.getData().dedApprovalLevels,
            dedStatus: deductionCreationRef.current.getData().dedStatus,
            dedActive: deductionCreationRef.current.getData().dedActive,
            dedSupplier: deductionCreationRef.current.getData().dedSupplier,
            author: user.username,
            dedReferenceStartDate:
              deductionCreationRef.current.getData().dedReferenceStartDate,
            dedReferenceEndDate:
              deductionCreationRef.current.getData().dedReferenceEndDate,
            dedRemark: deductionCreationRef.current.getData().dedRemark,
          });
        } catch (e) {
          setIsSubmitLoading(false);
        }
        reset();
        toast.success("Deduction updated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        try {
          const response = await addDeductionMaster({
            dedReference: deductionCreationRef.current.getData().dedReference,
            dedCompany: company,
            dedCurrency: currency,
            dedTransporter:
              deductionCreationRef.current.getData().dedTransporter,
            dedVehicle: deductionCreationRef.current.getData().dedVehicle,
            dedItem: deductionCreationRef.current.getData().dedItem,
            dedItemType: deductionCreationRef.current.getData().dedItemType,
            dedPeriod: deductionCreationRef.current.getData().dedPeriod,
            dedStart: deductionCreationRef.current.getData().dedStart,
            dedEnd: deductionCreationRef.current.getData().dedEnd,
            dedRequiredDate:
              deductionCreationRef.current.getData().dedRequiredDate,
            dedExecutionDate:
              deductionCreationRef.current.getData().dedExecutionDate,
            dedItemCost: deductionCreationRef.current.getData().dedItemCost,
            dedQuantity: deductionCreationRef.current.getData().dedQuantity,
            dedAmount: deductionCreationRef.current.getData().dedAmount,
            dedInstallmentAmount:
              deductionCreationRef.current.getData().dedInstallmentAmount,
            dedInstallments:
              deductionCreationRef.current.getData().dedInstallments,
            dedPaymentStatus:
              deductionCreationRef.current.getData().dedPaymentStatus,
            dedSerialNumber:
              deductionCreationRef.current.getData().dedSerialNumber,
            dedDescription:
              deductionCreationRef.current.getData().dedDescription,
            dedWarranty: deductionCreationRef.current.getData().dedWarranty,
            dedWarrantyEnds:
              deductionCreationRef.current.getData().dedWarrantyEnds,
            dedJob: deductionCreationRef.current.getData().dedJob,
            dedDistance: deductionCreationRef.current.getData().dedDistance,
            dedFuelInstruction:
              deductionCreationRef.current.getData().dedFuelInstruction,
            dedBehalfOf: deductionCreationRef.current.getData().dedBehalfOf,
            dedApprovalLevels:
              deductionCreationRef.current.getData().dedApprovalLevels,
            dedStatus: deductionCreationRef.current.getData().dedStatus,
            dedActive: deductionCreationRef.current.getData().dedActive,
            dedSupplier: deductionCreationRef.current.getData().dedSupplier,
            author: user.username,
            dedReferenceStartDate:
              deductionCreationRef.current.getData().dedReferenceStartDate,
            dedReferenceEndDate:
              deductionCreationRef.current.getData().dedReferenceEndDate,
            dedRemark: deductionCreationRef.current.getData().dedRemark,
          });
        } catch (e) {
          setIsSubmitLoading(false);
        }
        toast.success("Deduction added successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
        reset();
      }
      setIsSubmitLoading(false);
    }
  };
  const reset = () => {
    deductionCreationRef.current.resetForm();
    setEditMode(false);
    setEditDeduction(null);
  };
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchDeductionMaster({
      dedCode: codeRef.current.value,
      dedTransporter: transporter,
      dedVehicle: vehicle,
      dedSupplier: supplier,
      dedItem: item,
      dedPeriod: period,
      dedJob: job,
      status: status,
      active: active,
      from: fromDateRef.current.value,
      to: toDateRef.current.value,
      company: company,
      author: user.username,
    });
    console.log("search response", response);
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    setTransporter(null);
    setVehicle(null);
    setSupplier(null);
    setItemType(null);
    setItem(null);
    setPeriod(null);
    setJob(null);
    setActive(null);
    setStatus(null);
    codeRef.current.reset();
    fromDateRef.current.reset();
    toDateRef.current.reset();
    setSearchFieldReset(true);
  };
  const handleReportSearchSubmit = async (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    // e.preventDefault();
    if (tab === 2) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setReportSearchClicked(true);
      setReportSearchSubmitLoading(true);
    }
    const response = await reportSearchDeductionMaster({
      dedTransporter: reportTransporter,
      dedVehicle: reportVehicle,
      dedSupplier: reportSupplier,
      dedItemType: reportItemType,
      dedItem: reportItem,
      paymentStatus: paymentStatus,
      status: reportStatus,
      active: reportActive,
      company: company,
      author: user.username,
    });
    console.log("search response", response);
    setReportSearchRes(response);
    setReportSearchSubmitLoading(false);
  };
  const handleReportSearchReset = (e) => {
    e.preventDefault();
    setReportSupplier(null);
    setReportTransporter(null);
    setReportVehicle(null);
    setReportItemType(null);
    setReportItem(null);
    setPaymentStatus(null);
    setReportStatus(null);
    setReportActive(null);
    setSearchFieldReset(true);
  };
  const viewApprovalList = (dedId, detId) => {
    const handleViewClick = (e) => {
      e.stopPropagation(); // Prevent event propagation

      handleDownloadPopUpChange(dedId, detId);
    };

    const handleDownloadPopUpChange = async (dedId, detId) => {
      setShowCloseButton(true);
      const response = await getApprovedUserData(dedId, detId);
      const result = response.map((item) => ({
        ...item,
        lastModifiedDate:
          item.approvedStatus === "Approved" ? item.lastModifiedDate : null,
      }));
      setTableData(result);
      modalRef.current.showModal();
    };

    return (
      <Button
        className="ui primary button"
        style={{ display: "flex", alignItems: "center" }}
        onClick={handleViewClick}
        label="View Approved List"
      />
    );
  };

  const handleDelete = async (detId) => {
    setIsDeleting(true);
    const deletedNote = await dedTxnDelete(detId, user.username);

    if (deletedNote?.status === 200) {
      toast.success(deletedNote.data, {
        autoClose: 5000,
        containerId: "Main",
      });
      setDetId(null);
      setTimeout(() => {
        setUpdateNeeded(true);
      }, 500);
    } else {
      toast.error(deletedNote.data, {
        autoClose: 5000,
        containerId: "Main",
      });
    }
    setIsDeleting(false);
  };

  useEffect(
    (e) => {
      if (updateNeeded) {
        handleReportSearchSubmit().then((r) => null);
        setUpdateNeeded(false);
      }
    },
    [updateNeeded]
  );
  const handleBulkDrawerClose = () => {
    setIsBulkDrawerOpen(false);
  };

  const handleBulkResponseDrawerClose = () => {
    setIsBulkResponseDrawerOpen(false);
  };

  const handleBulkUpload = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    setIsLoading(true);
    const document = deductionBulkUploadRef.current.getData();
    if (document.file.length <= 0) {
      toast.error("Please add a file ! ", {
        autoClose: 5000,
        containerId: "Main",
      });
    } else {
      const uploadedFile = document.file?.[0];
      const formData = new FormData();
      formData.append("multipartFile", uploadedFile);
      formData.append("configId", 2);
      formData.append("userName", document.userName);
      formData.append("company", company);
      try {
        await uploadDeductionBulkData(formData);
        toast.success("Deduction bulk upload successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
        deductionBulkUploadRef.current.reset();
      } catch (error) {
        toast.error("Deduction bulk upload failed ! ", {
          autoClose: 5000,
          containerId: "Main",
        });
        console.warn(
          "Upload error ignored:",
          error.response?.data || error.message
        );
      }
    }
    setIsLoading(false);
    setIsSubmitLoading(false);
  };

  const handleDedBulkSearchSubmit = async (e) => {
    e.preventDefault();
    if (tab === 3) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setBulkSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchBulkDeduction({
      fromDate: fromDateRef.current.value,
      toDate: toDateRef.current.value,
      versionNumber:
        versionNumber.current.value === "" ? null : versionNumber.current.value,
      // chargeType: chargeType,
      proceedStatus: bulkProceedStatus !== 1,
      company: company,
      author: user.username,
    });
    setDedBulkSearchRes(response);
    setSearchSubmitLoading(false);
  };

  const handleDedBulkSearchReset = () => {
    fromDateRef.current.reset();
    toDateRef.current.reset();
    setChargeType(null);
    versionNumber.current.reset();
    setBulkProceedStatus(null);
  };

  const handleDedAdd = async (selectedType) => {
    try {
      switch (selectedType.id) {
        case 1:
          setDrawerTab(2);
          setIsBulkDrawerOpen(true);
          break;
        case 2:
          await downloadBulkTemplate(2);
          break;
      }
    } catch (error) {
      console.error("Error in handleChargeAdd:", error);
    }
  };

  const bulkDeductionOpt = [
    {
      id: 1,
      value: 1,
      text: "Bulk Deduction",
    },
    {
      id: 2,
      value: 2,
      text: "Template Download",
    },
  ];

  return (
    <>
      {/*<DeductionMasterForm />*/}
      <Modal minWidth={"600px"} ref={modalRef} closeButton={showCloseButton}>
        <>
          <Grid
            heading="Approval List"
            config={[
              {
                headerName: "Id",
                field: "apdId",
                sort: "asc",
                hide: true,
              },
              {
                headerName: "Approval Name",
                field: "approvalName",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Approver Name",
                field: "approvedBy",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Current Status",
                field: "approvedStatus",
                cellRenderer: StatusCellStyle,
              },
              {
                headerName: "Approved Date",
                field: "lastModifiedDate",
                cellRenderer: DateCellRenderer,
              },
            ]}
            content={tableData}
          />
        </>
      </Modal>

      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <Tab
            Icon={MinusCircle}
            onClick={() => {
              setTab(1);
              setDrawerTab(1);
            }}
            active={tab === 1}
            label="Deduction Search"
          />
          {/*<Tab*/}
          {/*  Icon={File}*/}
          {/*  onClick={() => {*/}
          {/*    setTab(2);*/}
          {/*  }}*/}
          {/*  active={tab === 2}*/}
          {/*  label="Deduction Report"*/}
          {/*/>*/}
          <Tab
            Icon={UploadCloud}
            onClick={() => {
              setDrawerTab(2);
              setTab(3);
            }}
            active={tab === 3}
            label="Deduction Bulk Upload"
          />
        </div>
        {tab === 1 ? (
          <div
            className="ui primary button"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              height: "40px",
            }}
            onClick={handleDrawerOpen}
          >
            <i className="plus icon"></i>
            <span>Add</span>
          </div>
        ) : tab === 3 ? (
          <ActionMenu
            title="Action"
            options={bulkDeductionOpt}
            onChangeHandler={handleDedAdd}
            actionMenuStyle={{ width: "8vw", marginRight: "10px" }}
          />
        ) : null}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>

          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Deduction Search</h4>
                <div className="four fields">
                  <Input
                    label="Deduction Code"
                    placeholder="Deduction Code"
                    name="dedCode"
                    ref={codeRef}
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setTransporter(null);
                    }}
                    onResultSelect={(data) => setTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    clearable={true}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setVehicle(data)}
                    onClear={() => {
                      setVehicle(null);
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "vehicle",
                    }}
                    label="Vehicle"
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setSupplier(null);
                    }}
                    onResultSelect={(data) => setSupplier(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Supplier",
                    }}
                    label="Supplier"
                  />
                  <Dropdown
                    label="Period"
                    placeholder="Period"
                    options={dedPeriodOptions}
                    style={{ height: "20px" }}
                    value={period}
                    onChange={(e, data) => {
                      setPeriod(data.value);
                    }}
                  />
                </div>
                <div className="five fields">
                  <Dropdown
                    label="Item Type"
                    placeholder="Item Type"
                    options={itemTypeOptions}
                    value={itemType}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setItemType(data.value);
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setItem(null);
                    }}
                    onResultSelect={(data) => setItem(data)}
                    api={getOtherRefDetails}
                    apiDependency={{
                      type: "item_type",
                      value: itemType,
                    }}
                    label="Item"
                    disabled={!itemType}
                  />

                  <SearchDropdown
                    key={1}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setJob(data)}
                    clearable={true}
                    onClear={() => {
                      setJob(null);
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "JOB",
                    }}
                    label="Job"
                  />

                  <Dropdown
                    label="Status"
                    placeholder="Status"
                    options={statusOptions}
                    value={status}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />

                  <Dropdown
                    label="Active"
                    placeholder="Status"
                    options={activeOptions}
                    value={active}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>
                <div className="five fields">
                  <Input
                    label="From Date"
                    type="date"
                    name="from_date"
                    placeholder="From Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="to_date"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                showDownloadButton={true}
                multiRowSelection={true}
                downloadParam={""}
                downloadAction="Deduction Master CSV Download"
                reportName={"Deduction Master Records.csv"}
                heading="Deduction Search"
                config={[
                  {
                    headerName: "Id",
                    field: "dedId",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "dedCode",
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                  },
                  {
                    headerName: "Item Type",
                    field: "temType",
                  },
                  {
                    headerName: "Item",
                    field: "temName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Transporter",
                    field: "transporter",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Supplier",
                    field: "supplier",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Vehicle",
                    field: "vehicle",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Period Type",
                    field: "periodName",
                  },
                  // {
                  //     headerName: "Period",
                  //     field: "dedPeriod",
                  // },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await deductionMasterById(props.data.dedId);
                  setEditDeduction(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Deduction Bulk Upload</h4>
                <div className="four fields">
                  <Dropdown
                    label="Item Type"
                    placeholder="Item Type"
                    options={itemTypeOptions}
                    value={reportItemType}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setReportItemType(data.value);
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onResultSelect={(data) => setReportItem(data)}
                    onClear={() => {
                      setReportItem(null);
                    }}
                    api={getOtherRefDetails}
                    apiDependency={{
                      type: "item_type",
                      value: reportItemType,
                    }}
                    label="Item"
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setReportTransporter(null);
                    }}
                    onResultSelect={(data) => setReportTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setReportVehicle(data)}
                    onClear={() => {
                      setReportVehicle(null);
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "vehicle",
                    }}
                    label="Vehicle"
                  />
                </div>
                <div className="four fields">
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setReportSupplier("");
                    }}
                    onResultSelect={(data) => setReportSupplier(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Supplier",
                    }}
                    label="Supplier"
                  />
                  <Dropdown
                    label="Payment Status"
                    placeholder="Payment Status"
                    options={paymentStatusOptions}
                    style={{ height: "5px" }}
                    value={paymentStatus}
                    onChange={(e, data) => {
                      setPaymentStatus(data.value);
                    }}
                  />

                  <Dropdown
                    label="Status"
                    placeholder="Status"
                    options={statusOptions}
                    value={reportStatus}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setReportStatus(data.value);
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleReportSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleReportSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {reportSearchClicked && (
          <>
            {reportSearchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={reportSearchFetchLoading}
                heading="Deduction Report"
                showDownloadButton={true}
                downloadParam=""
                downloadAction="Deduction Report Download"
                excelSheetDownload={true}
                downloadOnlySelected={false}
                content={reportSearchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "dedId",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Main Deduction Code",
                    field: "dedCode",
                  },
                  {
                    headerName: "Transactional Code",
                    field: "detdCode",
                  },
                  {
                    headerName: "Item Type",
                    field: "itemType",
                  },
                  {
                    headerName: "Item",
                    field: "itemName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Transporter",
                    field: "transporter",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Supplier",
                    field: "supplier",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Vehicle",
                    field: "vehicle",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Start Date",
                    field: "startDate",
                    cellRenderer: DateOnlyCellRenderer,
                    minWidth: 250,
                  },
                  {
                    headerName: "End Date",
                    field: "endDate",
                    cellRenderer: DateOnlyCellRenderer,
                    minWidth: 250,
                  },
                  // {
                  //     headerName: "Period Type",
                  //     field: "periodType",
                  // },
                  {
                    headerName: "Period",
                    field: "periodType",
                  },
                  {
                    headerName: "Total Amount",
                    field: "totalPeriodAmount",
                  },
                  {
                    headerName: "Installment Amount",
                    field: "installmentValue",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Complete Period Amount",
                    field: "completedPeriodAmount",
                  },
                  {
                    headerName: "Remaining Amount To Be Recover ",
                    field: "remainingAmountToBeRecovered",
                  },
                  {
                    headerName: "Payment Status",
                    field: "paymentStatus",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Deduction Status",
                    field: "deductionStatus",
                  },
                  {
                    headerName: "EV Number",
                    field: "evNumber",
                  },
                  {
                    headerName: "View Approved List",
                    field: "viewApprovalList",
                    cellRenderer: (params) => {
                      return viewApprovalList(
                        params.data.dedId,
                        params.data.detId
                      );
                    },
                    minWidth: 250,
                  },
                  {
                    headerName: "Oracle Process Status",
                    field: "oracleProcessStatus",
                    cellRenderer: ChargeCellStyle,
                  },
                  {
                    headerName: "Transaction Delete",
                    field: "delete",
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => {
                      return {
                        clickHandler: async () => {
                          setDetId(params.data.detId);
                          setDetCode(params.data.detdCode);
                          deleteRef.current?.openAlert();
                        },
                        label: "Transaction Delete",
                        Icon: MdDeleteForever,
                        className: "ui red button",
                        disabled: params.data.oracleProcessStatus
                          ? false
                          : true,
                      };
                    },
                    minWidth: 250,
                  },
                  {
                    headerName: "Warranty (Months)",
                    field: "warranty",
                  },
                  {
                    headerName: "Warranty Ends",
                    field: "warrantyEnds",
                  },
                  {
                    headerName: "Job",
                    field: "job",
                  },
                  {
                    headerName: "Serial Number",
                    field: "serialNumber",
                  },
                  {
                    headerName: "Description",
                    field: "description",
                  },
                  {
                    headerName: "Approval Level Name",
                    field: "approvalName",
                  },
                  {
                    headerName: "Approval Level",
                    field: "approvedStatus",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Created By",
                    field: "createdBy",
                  },
                  {
                    headerName: "Created Date",
                    field: "createdDate",
                    cellRenderer: DateCellRenderer,
                    minWidth: 250,
                  },
                  {
                    headerName: "Deduction Active",
                    field: "deductionActive",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 3 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>

          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>
                <div className="four fields">
                  <Input
                    label="From Date"
                    type="date"
                    name="from_date"
                    placeholder="From Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="to_date"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                  <Input
                    type="number"
                    step="0.0001"
                    label="Version Number"
                    placeholder="Version Number"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    ref={versionNumber}
                  />
                  <Dropdown
                    label="Proceed Status"
                    placeholder="Proceed Status"
                    options={bulkProceedStatusOptions}
                    value={bulkProceedStatus}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setBulkProceedStatus(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleDedBulkSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleDedBulkSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {bulkSearchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={dedBulkSearchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "jdehId",
                    sort: "desc",
                    hide: true,
                  },
                  // {
                  //   headerName: "Code",
                  //   field: "dedCode",
                  // },
                  {
                    headerName: "Version Number",
                    field: "jdehVersionNumber",
                  },
                  {
                    headerName: "File Name",
                    field: "jdehFileName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  // {
                  //   headerName: "Charge Type Name",
                  //   field: "jdehChargeTypeName",
                  //   cellRenderer: ResizableScrollingTextRenderer,
                  // },
                  {
                    headerName: "Proceed Status",
                    field: "proceedStatusLabel",
                    cellRenderer: BulkProceedStatusStyle,
                  },
                  {
                    headerName: "Created Date",
                    field: "createdDate",
                    cellRenderer: DateCellRenderer,
                    minWidth: 250,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await DeductionExcelLinesById(
                    props.data.jdehId
                  );
                  console.log("-------");
                  console.log(response);
                  setDedBulkDetailSearchRes(response);
                  setEditMode(true);
                  setIsBulkResponseDrawerOpen(true);
                  setDrawerTab(3);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ${detCode}...`} />
        </div>
      )}
      <CustomAlert
        ref={deleteRef}
        message={`Are you sure you want to delete ${detCode}?`}
        onAccept={() => {
          handleDelete(detId);
        }}
      />
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div
              className="blacklist-code-header"
              style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
            >
              <h3>Deduction Code: {editDeduction?.dedCode}</h3>
            </div>
          ) : null
        }
        body={
          <form className="drawer-content" onSubmit={handleSubmit}>
            <div style={{ width: "60vw", boxShadow: "none" }}>
              <div className="ui top attached tabular menu">
                <div
                  className={`item ${drawerTab === 1 ? "active" : ""}`}
                  onClick={() => {
                    setDrawerTab(1);
                  }}
                >
                  <span>
                    <MinusCircle
                      size={15}
                      style={{
                        marginRight: "5px",
                        color: `${
                          Object.keys(errorState.deductMasterErrors).length !==
                          0
                            ? "#e0b4b4"
                            : ""
                        }`,
                      }}
                    />
                  </span>
                  <label
                    style={{
                      color: `${
                        Object.keys(errorState.deductMasterErrors).length !== 0
                          ? "#e0b4b4"
                          : ""
                      }`,
                    }}
                  >
                    Deduction Creation
                  </label>
                </div>
              </div>

              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 1 ? "block" : "none" }}
              >
                <DeductionMasterForm
                  ref={deductionCreationRef}
                  errors={errorState.deductMasterErrors}
                  editMode={editMode}
                  currentValues={editMode ? editDeduction : null}
                  isLoading={isLoading}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {editMode ? (
                    <Button
                      type="submit"
                      disabled={
                        editDeduction !== null
                          ? editDeduction.dedPaymentStatus === 4
                          : false
                      }
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                      form={FORMS.DEDUCTION.DEDUCTION_MASTER.form}
                      module={MODULES.Finance}
                      section={FORMS.DEDUCTION}
                      authenticated={true}
                    />
                  ) : drawerTab === 1 && !isLoading ? (
                    <Button
                      type="submit"
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                      form={FORMS.DEDUCTION.DEDUCTION_MASTER.form}
                      module={MODULES.Finance}
                      section={FORMS.DEDUCTION}
                      authenticated={true}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />

      <SideDrawer
        open={isBulkDrawerOpen}
        handleDrawerClose={handleBulkDrawerClose}
        body={
          <form className="drawer-content" onSubmit={handleBulkUpload}>
            <div className={"deduction-card-container"}>
              <div style={{ width: "60vw", boxShadow: "none" }}>
                <div className="ui top attached tabular menu">
                  <Tab
                    Icon={Upload}
                    onClick={() => {
                      setDrawerTab(2);
                    }}
                    active={drawerTab === 2}
                    label="Bulk Upload"
                  />
                </div>

                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 2 ? "block" : "none" }}
                >
                  <DeductionBulkUpload
                    ref={deductionBulkUploadRef}
                    isLoading={isLoading}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {drawerTab === 2 && !isLoading ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.DEDUCTION.DEDUCTION_BULK_UPLOAD.form}
                        module={MODULES.Finance}
                        authenticated={true}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
      <SideDrawer
        open={isBulkResponseDrawerOpen}
        handleDrawerClose={handleBulkResponseDrawerClose}
        body={
          <div className={"deduction-card-container"}>
            <div style={{ width: "60vw", boxShadow: "none" }}>
              <div className="ui top attached tabular menu">
                <Tab
                  Icon={List}
                  onClick={() => {
                    setDrawerTab(3);
                  }}
                  active={drawerTab === 3}
                  label="Bulk Deduction"
                />
              </div>

              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 3 ? "block" : "none" }}
              >
                {searchSubmitLoading ? (
                  <LoadingSpinner />
                ) : (
                  <Grid
                    isLoading={searchFetchLoading}
                    content={dedBulkDetailSearchRes}
                    showDownloadButton={true}
                    multiRowSelection={true}
                    downloadParam={""}
                    downloadAction="Bulk Deduction CSV Download"
                    reportName={"Bulk Deduction Records.csv"}
                    config={[
                      {
                        headerName: "Id",
                        field: "deldRowId",
                        sort: "desc",
                        hide: true,
                      },
                      // {
                      //   headerName: "Code",
                      //   field: "dedCode",
                      // },
                      // {
                      //   headerName: "Deduction Detail Id",
                      //   field: "deldId",
                      // },
                      // {
                      //   headerName: "Deduction Excel Header Id",
                      //   field: "deldDehId",
                      // },
                      {
                        headerName: "Item Type",
                        field: "deldItemType",
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                      },
                      {
                        headerName: "Item",
                        field: "deldItem",
                      },
                      {
                        headerName: "Item Cost",
                        field: "deldItemCost",
                      },
                      {
                        headerName: "Quantity",
                        field: "deldQuantity",
                      },
                      {
                        headerName: "Period",
                        field: "deldPeriod",
                      },
                      {
                        headerName: "Installment",
                        field: "deldInstallments",
                      },
                      {
                        headerName: "Vehicle",
                        field: "deldVehicle",
                      },
                      {
                        headerName: "Supplier",
                        field: "deldSupplier",
                      },
                      {
                        headerName: "Execution Date",
                        field: "deldExecutionDate",
                      },
                      {
                        headerName: "Start Date",
                        field: "deldStartDate",
                      },
                      {
                        headerName: "Job",
                        field: "deldJob",
                      },
                      {
                        headerName: "Terminal Id",
                        field: "deldTerminalId",
                      },
                      // {
                      //   headerName: "Description",
                      //   field: "deldStatusDescription",
                      //
                      // },
                      // {
                      //   headerName: "Status",
                      //   field: "deldStatusDescription",
                      // },
                      // {
                      //   headerName: "Created By",
                      //   field: "createdBy",
                      //
                      // },
                      // {
                      //   headerName: "Created Date",
                      //   field: "createdDate",
                      // },
                      // {
                      //   headerName: "Last Modified By",
                      //   field: "lastModifiedBy",
                      // },
                      // {
                      //   headerName: "Last Modified Date",
                      //   field: "lastModifiedDate",
                      // },
                      {
                        headerName: "Status Description",
                        field: "deldStatusDescription",
                        width: "250",
                        minWidth: "250",
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Creation Status",
                        field: "deldChargeCreationStatus",
                        cellRenderer: BulkProceedStatusStyle,
                        pinned: "right",
                      },
                      {
                        headerName: "proceed Status",
                        field: "deldProceedStatus",
                        cellRenderer: BulkProceedStatusStyle,
                        pinned: "right",
                      },
                    ]}
                  />
                )}
              </div>
            </div>
          </div>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};
export default DeductionMaster;
